import { GLOBAL_SETTINGS_COLLECTION } from "./legal";

/** Document id under `globalSettings` for MayorX Bridge (desktop) rollout policy. */
export const GLOBAL_LEGACY_BRIDGE_DOC_ID = "legacyBridge";

export { GLOBAL_SETTINGS_COLLECTION };

/**
 * Platform-wide policy for the desktop bridge. Stored at
 * `globalSettings/legacyBridge`.
 */
export interface LegacyBridgeGlobalSettings {
  /** Minimum semver the bridge should report (e.g. "1.0.3"). Empty = no enforced minimum. */
  minBridgeVersion: string;
  updatedAt?: Date | null;
  updatedBy?: string | null;
}
